/** @file ikAxisAngle: a rotation about an axis (private stand-in for math M1 quatFromAxisAngle). */
import type { Quat } from '@zilo/pose3d-math/quat/quat';
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import { ikNormalize } from '@zilo/pose3d-pose/_internal/ikNormalize';

/** Right-handed rotation by `rad` about `axis` (normalised here). */
export function ikAxisAngle(axis: Vec3, rad: number): Quat {
  const [x, y, z] = ikNormalize(axis);
  const s = Math.sin(rad / 2);
  return [x * s, y * s, z * s, Math.cos(rad / 2)];
}
